import { createContext } from 'react';
import { Themes } from './types';
import { Path } from 'dot-path-value';
import { DEFAULT_THEME_LAYOUT } from './constants';

export type ThemeLayoutType = {
  sidebar: {
    compact?: boolean;
  };
};

export type ThemeContextType = {
  theme?: Themes;
  changeTheme: (themeName: Themes) => void;

  layout: ThemeLayoutType;
  updateLayout: (key: Path<ThemeLayoutType>, value: boolean) => void;
};

export const ThemeContext = createContext<ThemeContextType>({
  changeTheme: () => null,
  layout: DEFAULT_THEME_LAYOUT,
  updateLayout: () => {},
});